import { render, staticRenderFns } from "./space-data.vue?vue&type=template&id=db42bb7c"
import script from "./space-data.vue?vue&type=script&lang=js"
export * from "./space-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports